module.exports = __webpack_public_path__ + "4b16a31fa4455c0b26069a38b9efde9c.png";